import { Action } from '@ngrx/store';
import { FinancialDocument } from '../models/financial-document.model';

export enum ActionTypes {
    LOAD_FINANCIAL_DOCUMENTS  = '[Financial Documents Page] Load Financial Documents',
    CLEAR_FINANCIAL_DOCUMENTS = '[Financial Documents Page] Clear Financial Documents',
    SEARCH_DOCUMENTS          = '[Financial Documents Page] Search Documents',
    SORT_DOCUMENTS            = '[Financial Documents Page] Sort Documents',
    SELECT_DOCUMENT           = '[Financial Documents Page] Select Document',
    FLAG_DOCUMENT             = '[Financial Documents Page] Flag Document',
    UNFLAG_DOCUMENT           = '[Financial Documents Page] Unflag Documents',
    DOWNLOAD_EXCEL_REPORT     = '[Financial Documents Page] Download Excel Report',
    MARK_CHECK                = '[Financial Documents Page] Mark Check',
    ADD_FINANCIAL_DOCUMENTS   = '[Financial Documents API] Add Financial Documents',
    CLEAR_DOCUMENT            = '[Financial Documents API] Clear Document',
    UPDATE_DOCUMENT_DATA      = '[Financial Documents API] Update Document Data',
    UPDATE_DOCUMENTS_DATA     = '[Financial Documents API] Update Documents Data',
    ERROR = "[Financial Documents API] API error",
}

export class LoadFinancialDocuments implements Action {
    readonly type: string = ActionTypes.LOAD_FINANCIAL_DOCUMENTS;

    constructor(public payload: any = null) {}
}

export class AddFinancialDocuments implements Action {
    readonly type: string = ActionTypes.ADD_FINANCIAL_DOCUMENTS;

    constructor(public payload: FinancialDocument[]) {}
}

export class ClearFinancialDocuments implements Action {
    readonly type: string = ActionTypes.CLEAR_FINANCIAL_DOCUMENTS;

    constructor(public payload: any = null) {}
}

export class FlagDocument implements Action {
    readonly type: string = ActionTypes.FLAG_DOCUMENT;

    constructor(public payload: FinancialDocument) {}
}

export class UnflagDocument implements Action {
    readonly type: string = ActionTypes.UNFLAG_DOCUMENT;

    constructor(public payload: FinancialDocument) {}
}

export class SelectDocument implements Action {
    readonly type: string = ActionTypes.SELECT_DOCUMENT;

    constructor(public payload: number) {}
}

export class ClearDocument implements Action {
    readonly type: string = ActionTypes.CLEAR_DOCUMENT;

    constructor(public payload: any = null) {}
}

export class UpdateDocumentData implements Action {
    readonly type: string = ActionTypes.UPDATE_DOCUMENT_DATA;

    constructor(public payload: FinancialDocument) {}
}

export class UpdateDocumentsData implements Action {
    readonly type: string = ActionTypes.UPDATE_DOCUMENTS_DATA;

    constructor(public payload: FinancialDocument[]) {}
}

export class SortDocuments implements Action {
    readonly type: string = ActionTypes.SORT_DOCUMENTS;

    constructor(public payload: {columnKey: string, asc: boolean}) {}
}

export class DownloadExcelReport implements Action {
    readonly type: string = ActionTypes.DOWNLOAD_EXCEL_REPORT;

    constructor(public payload: boolean) {}
}

export class SetErrorState implements Action {
    readonly type: string = ActionTypes.ERROR;
}

export class SearchDocuments implements Action {
    readonly type: string = ActionTypes.SEARCH_DOCUMENTS;

    constructor(public payload: string) {}
}

export class MarkCheck implements Action {
    readonly type: string = ActionTypes.MARK_CHECK;

    constructor(public payload: boolean) {}
}

export type Actions =
    | LoadFinancialDocuments
    | AddFinancialDocuments
    | ClearFinancialDocuments
    | FlagDocument
    | UnflagDocument
    | SelectDocument
    | ClearDocument
    | UpdateDocumentData
    | UpdateDocumentsData
    | SortDocuments
    | DownloadExcelReport
    | SearchDocuments
    | MarkCheck;
